import React from 'react'
import { Text } from 'shared/components'

import * as styles from './styles'

const MobileInwinsEmptyStateComponent = () => {
	return (
		<div css={styles.emptyStateContainer}>
			<div css={styles.contentWrapper}>
				<div css={styles.textContainer}>
					<Text size={18} bold css={styles.titleText}>
						No Inwins here yet...
					</Text>
					<Text size={14} css={styles.subtitleText}>
						You can make Inwin so that it<br />
						appears in the history
					</Text>
				</div>

				<div css={styles.imageContainer}>
					<img
						src="./img/inwins-history-empty.png"
						alt="No InWins"
						css={styles.emptyImage}
					/>
				</div>
			</div>
		</div>
	)
}

export default MobileInwinsEmptyStateComponent 